

/**
 * Gera um id unico com 8 digitos alfanumerico para enviar com cada pedido e assim garantir que o pedido seja unico.
 * @returns {string} id unico com 8 digitos alfanumerico
 */
export const gerarIdUnico = () => {
    let alfanumerico = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    
    let id = ""
    for (let index = 0; index < 8; index++) {
        let random = getRandomInt(alfanumerico.length - 1)
        id += alfanumerico[random]
    }
    return id.toUpperCase() 
}

function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }
  